import React from "react";
import Tooltip from "@mui/material/Tooltip";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import useLongPress from "../../../../../helpers/useLongPress";

function CopilotShiftCard({
  shift,
  shiftColor,
  fullName,
  displayLabel,
  onLongPress,
  onClick,
  get_t_str,
}) {
  const defaultOptions = {
    shouldPreventDefault: true,
    delay: 500,
  };

  const longPressEvent = useLongPress(
    onLongPress,
    onClick,
    defaultOptions
  );

  return (
    <div
      {...longPressEvent}
      className={`relative text-xs px-2 py-1 ${shiftColor} text-white rounded shadow-sm cursor-pointer opacity-40 hover:opacity-70 transition-opacity`}
    >
      <div>
        <div className="flex items-center gap-1">
          <AutoAwesomeIcon sx={{ fontSize: 10, color: '#c4b5fd' }} />
          <div className="font-semibold truncate text-white text-[10px] leading-tight">
            {fullName || (shift.store_team_member === null ? 'Open shift' : 'No Name')}
          </div>
        </div>
        <div className="truncate text-white text-[9px] leading-snug">
          {get_t_str && get_t_str(shift.shift_start)} - {get_t_str && get_t_str(shift.shift_end)}{shift.business_decline ? " (BD)" : ""} ({displayLabel})
        </div>
      </div>
    </div>
  );
}

export default CopilotShiftCard;
